import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Edit, Eye, Trash2 } from "react-feather";
import TooltipIcons from "../../common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../common/tooltip-content/refresh";
import CollapesIcon from "../../common/tooltip-content/collapes";
import { useDeleteUserMutation, useGetAllUsersQuery } from "../../redux/api/userApi";
import Table from "../../pagination/datatable";
import UserModal from "./userModal";
import toast from "react-hot-toast";

const UserList = () => {
  const {data: userResponse, refetch} = useGetAllUsersQuery();
  const [deleteUser] = useDeleteUserMutation();
  const [selectedUser, setSelectedUser] = useState(null);
  const [isAddMode, setIsAddMode] = useState(false);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  console.log("cusomter", userResponse)

  const handleDeleteUser = async () => {
    console.log("Deleting user with ID:", deleteUserId);
    if (!deleteUserId) {
      console.error("No user ID provided for deletion");
      return;
    }
    
    try {
      await deleteUser(deleteUserId).unwrap();
      toast.success("User Deleted Successfully");
      refetch(); // Refresh the user list
    } catch (error) {
      // console.error("Delete error:", error);
      toast.error(`Unable to delete User:`);
    } finally {
      setShowDeleteModal(false);
      setDeleteUserId(null);
    }
  }
  const openDeleteModal = (id) => {
    setDeleteUserId(id);
    setShowDeleteModal(true);
  }

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      sorter: (a, b) => a.firstName?.length - b.firstName?.length,
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'], // Always visible
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      sorter: (a, b) => a.lastName?.length - b.lastName?.length,
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'], // Always visible
    },
    {
      title: "User Name",
      dataIndex: "userName",
      sorter: (a, b) => a.userName?.length - b.userName?.length,
      responsive: ['md', 'lg', 'xl'], // Hide on xs and sm
    },
    {
      title: "Phone",
      dataIndex: "mobile",
      sorter: (a, b) => a.mobile?.length - b.mobile?.length,
      responsive: ['md', 'lg', 'xl'], // Hide on xs and sm
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => a.email?.length - b.email?.length,
      responsive: ['md', 'lg', 'xl'], // Hide on xs and sm
    },
    {
      title: "Address",
      dataIndex: "Address",
      responsive: ['md', 'lg', 'xl'], // Hide on xs and sm
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>
            
       
            
            <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="modal" 
              data-bs-target="#add-user"
              onClick={() => {
                setSelectedUser(record);
                setIsAddMode(false);     
              }}
            >
              <Edit className="feather-edit" />
            </Link>
            
            <Link
              className="confirm-text p-2"
              onClick={(e) => {
                e.preventDefault();
                openDeleteModal(record._id);
              }}
            >
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'], // Always visible
    },
];
const expandable = {
  expandedRowRender: (record) => (
      <div style={{ padding: '10px' }}>
          <p><strong>User Name:</strong> {record.userName || "-"}</p>
          <p><strong>Phone:</strong> {record.mobile || "-"}</p>
          <p><strong>Email:</strong> {record.email || "-"}</p>
          <p><strong>Address:</strong> {record.Address || "-"}</p>
      </div>
  ),
  rowExpandable: (record) => true,
  expandRowByClick: true,
};


const excelOptions = {
  fileName: 'User_List',
  sheetName: 'Users',
  columns: [
    { key: 'firstName', header: 'First Name' },
    { key: 'lastName', header: 'Last Name' },
    { key: 'userName', header: 'Username' },
    { key: 'mobile', header: 'Phone' },
    { key: 'email', header: 'Email' },
    { key: 'Address', header: 'Address' }
  ],
  data: userResponse?.map(user => ({
    firstName: user.firstName,
    lastName: user.lastName,
    userName: user.userName,
    mobile: user.mobile,
    email: user.email,
    Address: user.Address
  })) || []
};

const pdfOptions = {
  fileName: 'User_List',
  title: 'User List',
  columns: [
    { key: 'firstName', header: 'First Name' },
    { key: 'lastName', header: 'Last Name' },
    { key: 'userName', header: 'Username' },
    { key: 'mobile', header: 'Phone' },
    { key: 'email', header: 'Email' },
    { key: 'Address', header: 'Address' }
  ],
  data: userResponse?.map(user => ({
    firstName: user.firstName,
    lastName: user.lastName,
    userName: user.userName,
    mobile: user.mobile,
    email: user.email,
    Address: user.Address
  })) || [],
  fileNamePrefix: 'Users'
};
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>UserList</h4>
                <h6>Manage your UserList</h6>
              </div>
            </div>
            <ul className="table-top-head">
            <TooltipIcons excelOptions={excelOptions} pdfOptions={pdfOptions}/>
              <RefreshIcon />
              <CollapesIcon />

            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#add-user"
                onClick={() => {
                  setSelectedUser(null); // Clear selection
                  setIsAddMode(true);       // Set to add mode
                }}
              >
              <i className='ti ti-circle-plus me-1'></i>
                Add User
              </Link>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set">
              </div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                     Status
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Inactive
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        New Joiners
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <Table
                  className="table datanew"
                  columns={columns}
                  expandable={expandable}
                  dataSource={userResponse}
                  key={userResponse?._id}
                  // rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>

      <UserModal
  // key={isAddMode ? "add" : selectedUser?._id || "add"} 
  isEdit={!isAddMode}
  userData={selectedUser}
  onSuccess={() => {
  
    setSelectedUser(null);
    refetch();
 
  }}
/>
       {/* <UserModal/> */}
       


       {showDeleteModal && (
        <div className="modal fade show" id="delete-modal" style={{display: 'block'}}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-5">
              <div className="modal-body text-center p-0">
                <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
                  <i className="ti ti-trash fs-24 text-danger" />
                </span>
                <h4 className="fs-20 text-gray-9 fw-bold mb-2 mt-1">
                  Delete User
                </h4>
                <p className="text-gray-6 mb-0 fs-16">
                  Are you sure you want to delete this user?
                </p>
                <div className="d-flex justify-content-center mt-3">
                  <button
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary fs-13 fw-medium p-2 px-3"
                    onClick={handleDeleteUser}
                  >
                    Yes Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>

  );
};

export default UserList;
